export default __webpack_public_path__ + "static/media/view-pwd-blue.e8a4b536.svg";